import gql from 'graphql-tag'

export const GET_AUDIO_STREAM_UI_CONTEXT = gql`
  query getAudioStreamUIContext {
    audioStreamUIContext @client {
      agentAwake,
      noteId,
      noteTypeId,
      sectionId,
      patientId,
      problemBasedSections {
        idNamePair
      },
      transcription,
      isScriptChange
    }
  }
`

export const SET_AUDIO_STREAM_UI_CONTEXT = gql`
  mutation setAudioStreamUIContext($audioStreamUIContext: AudioStreamUIContext) {
    setAudioStreamUIContext(audioStreamUIContext: $audioStreamUIContext) @client
  }
`

export const GET_AUDIO_STREAM_FORMAT = gql`
  query getAudioStreamFormat {
    audioStreamFormat @client {
      channels,
      bitDepth,
      encoding,
      sampleRate,
      source
    }
  }
`

export const SET_AUDIO_STREAM_FORMAT = gql`
  mutation setAudioStreamFormat($audioStreamFormat: AudioStreamFormat) {
    setAudioStreamFormat(audioStreamFormat: $audioStreamFormat) @client
  }
`

export const GET_SOCKET_AUTHENTICATED = gql`
  query getIsSocketAuthenticated {
    socket @client {
      isAuthenticated
    }
  }
`

export const SET_CREATE_AMWELL_NOTE = gql`
  mutation setCreateAmwellNote($createNote: Boolean) {
    setCreateAmwellNote(createNote: $createNote) @client
  }
`

export const GET_CREATE_AMWELL_NOTE = gql`
  query getCreateAmwellNote {
    createNote @client
  }
`

export const SET_SOCKET_AUTHENTICATED = gql`
  mutation setSocketAuthenticated($isSocketAuthenticated: Boolean) {
    setSocketAuthenticated(isSocketAuthenticated: $isSocketAuthenticated) @client
  }
`

export const SET_AUDIO_PROCESSED = gql`
  mutation setAudioProcessed($isProcessed: Boolean) {
    setAudioProcessed(isProcessed: $isProcessed) @client
  }
`

export const GET_AUDIO_PROCESSED = gql`
  query getAudioProcessed {
    isProcessed @client
  }
`
